import { Component, HostListener, Input, OnInit } from '@angular/core';
import { PreloadImgComponent } from 'app/core/directives/preload-img/preload-img.component';
import { TYPE_SECTIONS } from 'app/core/models/constans.model';

import { ActivatedRoute } from '@angular/router';
import { Menu, SectionMenu } from '../../models/menu.model';
import { MenuService } from '../../services/menu.service';

@Component({
    selector: 'app-menu-pdf',
    templateUrl: './menu-pdf.component.html',
    styleUrls: ['./menu-pdf.component.scss'],
    standalone: false
})
export class MenuPdfComponent extends PreloadImgComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  selectedSection: SectionMenu | undefined = undefined;
  /**
   * Indica el idioma seleccionado
   */
  language: string | undefined;
  /**
   * Tipos de secciones
   */
  readonly TYPE_SECTIONS = TYPE_SECTIONS;
  constructor(
    private menuService: MenuService,
    private route: ActivatedRoute
  ) {
    super();
  }

  /**
   * Setea si se debe visualizar o no el boton de
   * subir al inicio dependiendo si el usuario
   * hizo alguna navegacion en la pagina
   */
  @HostListener('body:scroll', ['$event'])
  onWindowScroll() {
    const scroll = window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    const scrollButton = document.getElementById('scrollButton');

  }


  ngOnInit(): void {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
    if (this.route.snapshot.params.section) {
      this.goToSection();
    }
  }

  /**
   * Detecta que seleccion fue seleccionada
   * para visualizar sus items
   *
   * @param section seccion seleccionada
   */
  selectSection(section: SectionMenu) {
    this.selectedSection = section;
    this.filterSection(section.name);
  }


  /**
   * Navega la pagina hasta el contenido de la seccion
   * seleccionada
   *
   * @param section seccion a filtrar
   */
  filterSection(section: string): void {
    setTimeout(() => {
      const sectionSelect = document.getElementById(section + 'section');
      if (sectionSelect) {
        sectionSelect.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }, 200);
  }

  /**
   * Intercambia los valores del lenguaje seleccionado
   */
  selectLanguage(): void {
    if (this.language === 'ES') {
      this.language = 'EN';
      this.menuService.setLang('EN');
    } else {
      this.menuService.setLang('ES');
      this.language = 'ES';
    }
  }

  setBackground(): string {
    if (this.menu.shapeColor === 'noInvert') {
      return this.menu.color;
    }
    return this.menu.colorText;
  }

  setColorText(): string {
    if (this.menu.shapeColor === 'noInvert') {
      return this.menu.colorText;
    }
    return this.menu.color;
  }


  /**
   * Navega a la seccion seleccionada
   */
  private goToSection() {
    setTimeout(() => {
      this.selectSection(this.menu.sections[parseInt(this.route.snapshot.params.section, 10)]);
    }, 2000);
  }


}
